module.exports = __webpack_public_path__ + "static/extremo-3080def1e05ad5c46e6d3a85f8c80b08.png";